import ChangeView from './ChangeView'
import Tabs from './Tabs'
import Collector from '../../triggers/collector'
import BatchCollector from '../../triggers/collector/batchCollector'
import Importer from '../../triggers/importer'
import Recycle from '../../triggers/recycle'
import ExportStatistics from '../../triggers/exportStatistics'
import ExportProblemTable from '../../triggers/exportProblemTable'
import Recovery from '../../triggers/recovery'
import Exporter from '../../triggers/exporter'
import BatchEditor from '../../triggers/editor'
import Review from '../../triggers/review'
import Delete from '../../triggers/delete'
import Reporter from '../../triggers/reporter'
import SynchroCase from '../../triggers/synchroCase'
import AreaImporter from '../../triggers/areaImporter'
import Back from '../../triggers/back'
import Share from '../../triggers/share'
import StandardBindLayouts from '../../triggers/standard-bind-layouts'
import ColumnConfig from '../../triggers/columnConfig'
import BatchStatus from '../../triggers/batch-status'
import StandardSplit from '../../triggers/standard-split'
import ExportAreaFile from '../../triggers/export-area-file'
import ExportMap from '../../triggers/export-map'

export const TriggersMap = {
  collector: Collector,
  batchCollector: BatchCollector,
  importer: Importer,
  areaImporter: AreaImporter,
  exporter: Exporter,
  recycle: Recycle,
  exportStatistics: ExportStatistics,
  exportProblemTable: ExportProblemTable,
  recovery: Recovery,
  back: Back,
  filter: null,
  review: Review,
  delete: Delete,
  editor: BatchEditor,
  changeView: ChangeView,
  reporter: Reporter,
  synchroCase: SynchroCase,
  tabs: Tabs,
  share: Share,
  bindLayouts: StandardBindLayouts,
  columnConfig: ColumnConfig,
  batchStatus: BatchStatus,
  standardSplit: StandardSplit,
  exportAreaFile: ExportAreaFile,
  exportMap: ExportMap,
}

const defaulLinkStyle = {
  gap: '8px',
  fontSize: '14px',
}
export const defaultElementsConfig = {
  back: {
    lable: '返回',
    props: { type: 'primary' },
    buttonStyle: {},
    linkStyle: defaulLinkStyle,
  },
  collector: {
    lable: '新建',
    props: { type: 'primary' },
    buttonStyle: {},
    linkStyle: defaulLinkStyle,
  },
  batchCollector: {
    lable: '新建',
    props: { type: 'primary' },
    buttonStyle: {},
    linkStyle: defaulLinkStyle,
  },
  batchEdit: {
    lable: '批量编辑',
    props: { type: 'primary' },
    buttonStyle: {},
    linkStyle: defaulLinkStyle,
  },
  importer: {
    lable: '导入',
    props: { type: 'primary' },
    buttonStyle: {},
    linkStyle: defaulLinkStyle,
  },
  areaImporter: {
    lable: '上传点位',
    props: { type: 'primary' },
    buttonStyle: {},
    linkStyle: defaulLinkStyle,
  },
  exporter: {
    lable: '导出',
    props: { type: 'primary' },
    buttonStyle: {},
    linkStyle: defaulLinkStyle,
  },
  exportMap: {
    lable: '导出',
    props: { type: 'primary' },
    buttonStyle: {},
    linkStyle: defaulLinkStyle,
  },
  recycle: {
    lable: '回收站',
    props: { type: 'primary' },
    buttonStyle: {},
    linkStyle: defaulLinkStyle,
  },
  exportStatistics: {
    lable: '导出统计表',
    props: { type: 'primary' },
    buttonStyle: {},
    linkStyle: defaulLinkStyle,
  },
  exportProblemTable: {
    lable: '导出问题大表',
    props: { type: 'primary' },
    buttonStyle: {},
    linkStyle: defaulLinkStyle,
  },
  recovery: {
    lable: '恢复',
    props: { type: 'primary' },
    buttonStyle: {},
    linkStyle: defaulLinkStyle,
  },
  review: {
    lable: '批量审核',
    props: { type: 'default', textColor: '#444444', borderColor: '#94A4B8' },
    buttonStyle: {},
    linkStyle: defaulLinkStyle,
  },
  editor: {
    lable: '批量编辑',
    props: { type: 'default', textColor: '#444444', borderColor: '#94A4B8' },
    buttonStyle: {},
    linkStyle: defaulLinkStyle,
  },
  delete: {
    lable: '批量删除',
    props: { type: 'primary' },
    buttonStyle: {},
    linkStyle: defaulLinkStyle,
  },
  standardSplit: {
    lable: '拆分指标',
    props: { type: 'primary' },
    buttonStyle: {},
    linkStyle: defaulLinkStyle,
  },
  reporter: {
    lable: '生成报告',
    props: { type: 'default', textColor: '#444444', borderColor: '#94A4B8' },
    buttonStyle: {},
    linkStyle: defaulLinkStyle,
  },
  synchroCase: {
    lable: '同步当天案件',
    props: { type: 'primary' },
    buttonStyle: {},
    linkStyle: defaulLinkStyle,
  },
  share: {
    lable: '分享',
    props: { type: 'primary' },
    buttonStyle: {},
    linkStyle: defaulLinkStyle,
  },
  bindLayouts: {
    lable: '根据指标生成layouts',
    props: { type: 'primary' },
    buttonStyle: {},
    linkStyle: defaulLinkStyle,
  },
  columnConfig: {
    lable: '设置',
    props: { type: 'primary' },
    buttonStyle: {},
    linkStyle: defaulLinkStyle,
  },
  batchStatus: {
    lable: '批量操作',
    props: { type: 'primary' },
    buttonStyle: {},
    linkStyle: defaulLinkStyle,
  },
}
